import React from "react";
import ContentGutter from "../../ContentGutter";
import SiteWrapper from "../../SiteWrapper";
import t, { AsHtml } from "../../../utils/translate";
import responsiveImages from "../../../utils/responsiveImages";

import styles from "./styles.module.scss";

export default function EliSequenceChart({
  renderHeader = true,
  renderCaption = true
}) {
  const images = [
    {
      altTag: "",
      url: t("SEQUENCE_ELIGIBLE_CHART_IMAGE_V2")
    },
    {
      altTag: "",
      url: t("SEQUENCE_ELIGIBLE_CHART_IMAGE_DESKTOP_V2")
    }
  ];
  return (
    <ContentGutter>
      <SiteWrapper size="small">
        {renderHeader && (
          <div className={styles.chartHeader}>
            {t("SEQUENCE_ELIGIBLE_CHART_HEADER")}
          </div>
        )}
        <div className={styles.chart}>
          {responsiveImages(images, "block", "0 auto", "100%", "0")}
        </div>
        {renderCaption && (
          <AsHtml
            value={t("SEQUENCE_ELIGIBLE_CHART_CAPTION")}
            tagType="p"
            className={styles.caption}
          />
        )}
      </SiteWrapper>
    </ContentGutter>
  );
}
